import { useQuery } from "react-query";

import { IParamsCombinationRules } from "~/entity/CombinationRules/model/schema";

import { useCombinationRules } from "./useCombinationRules";

export const COMBINATION_RULES_QUERY_KEY = "combinationRules";

export const useGetCombinationRules = (params: IParamsCombinationRules) => {
  const { rulesGet } = useCombinationRules();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [COMBINATION_RULES_QUERY_KEY, params],
    queryFn: () => rulesGet(params),
  });

  return {
    rules: data?.data?.items,
    total: data?.data?.total,
    isLoading,
    isError,
    refetch,
  };
};
